// extracted by mini-css-extract-plugin
export var cartIcon = "_of-0";
export var cartIconContainer = "_of-1";